import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import Footer from './Components/Footer/Footer'
import Header from './Components/Header/Header'
import Home from './Components/Home'

const App = () => {
  const useRecaptchaEnterprise = process.env.REACT_APP_USE_RECAPTCHA_ENTERPRISE === 'true'

  return (
        <div className="App">
            {
                useRecaptchaEnterprise
                  ? <GoogleReCaptchaProvider
                        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
                        useEnterprise={useRecaptchaEnterprise}
                        useRecaptchaNet={false}
                        scriptProps={{ async: true, defer: true, appendTo: 'body' }}>
                        <AppContent />
                    </GoogleReCaptchaProvider>
                  : <AppContent />
            }
        </div>
  )
}

const AppContent = () => {
  return <BrowserRouter>
            <Header/>
            <main className="AppBody">
                <Routes>
                    <Route path="/" exact element={<Home/>}></Route>
                </Routes>
            </main>
            <Footer />
        </BrowserRouter>
}

export default App
